<template>
  <section class="service-parts-trade-info container-fluid" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="trade-background row">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-md-offset-6">
            <div class="info-box">
              <h2>Value Your Trade</h2>
              <p>At Auto Dealer, we base our estimates on factors such as year, make, model, and trim of your vehicle when determining a trade-in value. Making the decision to trade-in or sell your car, truck, minivan, SUV or crossover is simple when you're given the most accurate numbers available from Auto Dealer. Make the confident choice and drive off our lot in a brand-new {{brandName}} <a href="#">{{images.sedans[0].modelName}}</a>, <a href="#">{{images.suvs[0].modelName}}</a>, <a href="#">{{images.suvs[1].modelName}}</a><span v-if="images.trucks.length > 0">, <a href="#">{{images.trucks[0].modelName}}</a></span> or more from Auto Dealer in City, State!</p>
              <a class="btn service-btn" href="#">Value Your Trade</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="service-background row">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="info-box">
              <h2>Service Department</h2>
              <p>The service staff and technicians at Auto Dealer are highly trained on all factory services for your car. Stop by and find out what our customers, their family and friends have discovered and come to depend on: for maintenance, repairs, warranty concerns on all {{brandName}} vehicles. Auto Dealer defines service excellence.</p>
              <p>The Auto Dealer service team look forward to making your ownership experience as enjoyable as it is meant to be.</p>
              <a class="btn service-btn" href="#">Schedule Service</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="parts-background row">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-md-offset-6">
            <div class="info-box">
              <h2>Genuine OEM Parts</h2>
              <p>Auto Dealer boasts an on-site parts department that will help you secure all the genuine {{brandName}} parts you need to complete a job on your {{brandName}} vehicle today! Our team members are knowledgeable on all things {{brandName}} and are eager to hear about the upcoming repair you plan on completing. From vehicle belts and hoses to accessories that give your vehicle a personal touch, we have your parts needs covered!</p>
              <p>If you'd like to take advantage of such parts, but don't have a wealth of mechanical knowledge, head to our <a href="#">service department</a> for assistance. We'll happily install your items so that you can get back to exploring the streets of City. Thank you for allowing Auto Dealer to assist with all your service needs!</p>
              <a class="btn service-btn" href="#">Search Parts</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  },
  mounted() {

  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.service-parts-trade-info {
  background: #fff;
  font-family: 'Helvetica Neue', Arial, sans-serif;
}
.service-parts-trade-info .service-background, .service-parts-trade-info .parts-background, .service-parts-trade-info .trade-background {
  background-size: cover;
  background-position: center;
  margin: 40px -15px;
  padding-bottom: 0;
}
.service-parts-trade-info .trade-background {
  background-image: url(../../static/images/trade-bg-keys-and-car.jpeg);
}
.service-parts-trade-info .service-background {
  background-position: right;
  background-image: url(../../static/images/service-stock-img.jpeg);
}
.service-parts-trade-info .parts-background {
  background-image: url(../../static/images/parts-service-stock-image.jpeg);
}

@media (min-width:1600px){
  .service-parts-trade-info .service-background, .service-parts-trade-info .parts-background, .service-parts-trade-info .trade-background {
    margin: 150px -15px !important;
  }
}

.service-parts-trade-info .info-box {
  background: #fffc;
  color: #000;
  padding: 15px;
  font-size: 16px;
  height: 100%;
  margin-bottom: 0;
  box-shadow: none;
}
.service-parts-trade-info .info-box p a {
  color: var(--primary-color) !important;
  font-weight: 600;
}
.service-parts-trade-info[data-brand="cjdr"] .info-box p a {
  color: var(--secondary-color) !important;
}
.service-parts-trade-info .service-btn {
	color: #fff !important;
  background: var(--primary-color);
  padding: 6px 30px;
  border-radius: 4px;
  text-transform: uppercase;
  font-size: 20px;
  margin: 15px auto;
  box-shadow: 2px 13px 27px -10px #0F032C;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  transform: perspective(1px) translateZ(0);
  -webkit-transition-property: transform;
  transition-property: transform;
}
.service-parts-trade-info[data-brand="cjdr"] .service-btn {
  background: var(--secondary-color);
}
.service-parts-trade-info .service-btn:hover {
	text-decoration: none;
  transform: scale(.97);
  box-shadow: 0px 5px 25px -6px #0F032C;
}
@media (max-width:768px) {
  .service-parts-trade-info .service-background, .service-parts-trade-info .parts-background, .service-parts-trade-info .trade-background {
    padding: 15px 0;
  }
 .service-parts-trade-info .info-box {
    border-radius: 8px;
}
  .service-parts-trade-info .service-btn {
    display: block;
    padding: 5px 10px;
  }
}
</style>
